const marfin = {
  graphqlEndpoint: {
    test: "https://test-api.marfin.app/graphql",
    prod: "https://api.marfin.app/graphql",
  },
};

export default marfin;
